<template>
  <span
    v-if="current"
    :class="{
      'text-danger strong': differenceIsMajor,
      'text-warning': differenceIsMinor,
      'text-success': latestIsCurrent
    }"
    v-tooltip.top.force="differenceIsMajor || differenceIsMinor ? `${latest} is available` : null"
  >
    <i class="fa-exclamation-triangle fa-fw" :class="{ far: differenceIsMinor, fas: differenceIsMajor }" v-if="differenceIsMajor || differenceIsMinor"/>
    {{ current }}
  </span>
  <span v-else class="text-muted">
    Unknown
  </span>
</template>

<script>
import { eq, diff } from 'semver'

export default {
  props: {
    current: String,
    latest: String
  },

  computed: {
    difference () {
      try {
        return diff(this.current, this.latest)
      } catch (error) {
        return null
      }
    },

    latestIsCurrent () {
      try {
        return eq(this.current, this.latest)
      } catch (error) {
        return false
      }
    },

    differenceIsMajor () {
      return this.difference === 'major'
    },

    differenceIsMinor () {
      if (this.differenceIsMajor) {
        return false
      }

      return this.difference === 'minor' || this.difference === 'patch' || this.difference === 'prerelease'
    }
  }
}
</script>
